<script setup lang="ts">
    import { useAppStore, useAuthStore, useDepartmentStore, useEmployeeStore, useLocationStore } from '#imports';

    /* Store variables */
    const { isMobile } = storeToRefs(useAppStore());
    const { currentLocationId, profile } = storeToRefs(useAuthStore());
    const departmentStore = useDepartmentStore();
    const { fetchDepartments } = departmentStore;
    const employeeStore = useEmployeeStore();
    const { fetchEmployees } = employeeStore;
    const locationStore = useLocationStore();
    const { fetchLocations } = locationStore;

    await fetchLocations();
    fetchEmployees(currentLocationId.value);
    fetchDepartments(currentLocationId.value);
</script>

<template>
    <v-layout>
        <SiteAppBar />
        <div v-if="profile && profile.id" class="w-100">
            <SiteNavDrawer />
            <v-main class="w-100">
                <v-container
                    :class="isMobile ? 'px-0' : ''"
                    style="margin-bottom: 128px;"
                    fluid>
                    <slot></slot>
                </v-container>
                <SiteFooter />
            </v-main>
        </div>
    </v-layout>
</template>